<template>
  <el-input
    v-model="id"
    type="textarea"
    :placeholder="placeholder || $t('inputText')"
    :maxlength="maxlength"
    :show-word-limit="showWordLimit"
    :disabled="disabled"
    :rows="rows"
    :resize="resize"
    class="full-width"
  />
</template>

<script>
import { MAX_LENGTH } from '@/utils/constants';
export default {
  name: 'BjTextarea',
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '',
    },
    rows: {
      type: Number,
      default: 4,
    },
    showWordLimit: {
      type: Boolean,
      default: true,
    },
    maxlength: {
      type: Number,
      default: MAX_LENGTH.REMARK,
    },
    /** 控制是否能被用户缩放 */
    resize: {
      type: String,
      default: 'none',
      validator: value => {
        return ['none', 'both', 'horizontal', 'vertical'].indexOf(value) !== -1;
      },
    },
  },
  data() {
    return {
      id: null,
    };
  },
  watch: {
    value: {
      handler(v) {
        this.id = v;
      },
      immediate: true,
    },
    id(v) {
      this.$emit('input', v);
    },
  },
};
</script>

<style></style>
